export const accreditationNames = {
  AFA: 'Association of Financial Advisers (AFA)',
  CPA: 'Certified Practising Accountant (CPA)',
  CAANZ: 'Chartered Accountants Australia &amp; New Zealand (CA ANZ)',
  FAAA: 'Financial Advice Association Australia (FAAA)',
  FBAA: 'Finance Broker Association of Australia (FBAA)',
  FPA: 'Financial Planning Association (FPA)',
  MFAA: 'Mortgage &amp; Finance Association of Australia (MFAA)',
  NIBA: 'National Insurance Brokers Association (NIBA)',
  ASFA: 'The Association of Superannuation Funds of Australia (ASFA)',
  AFMA: 'The Australian Financial Markets Association (AFMA)',
  FINSIA: 'The Financial Services Institute of Australasia (FINSIA)',
  SMSFA: 'The SMSF Association (SMSFA)',
  SIAA: 'The Stockbrokers and Investment Advisers Association (SIAA)',
  Other: 'Other (Please Specify)',
};



// WEBPACK FOOTER //
// ./src/constants/accreditation.js